import request from '@/config/axios'

export interface LiveStatRoomSummaryVO {
  id?: number
  title?: string
  totalViewCount?: number
  viewerCount?: number
  totalLikeCount?: number
  maxOnlineCount?: number
  totalWatchSeconds?: number
  giftCount?: number
  giftAmount?: number
  commentCount?: number
  reservationCount?: number
}

export interface LiveStatAnchorRankVO {
  id?: number
  userId?: number
  realName?: string
  avatar?: string
  liveCount?: number
  totalViewCount?: number
  totalLikeCount?: number
  maxOnlineCount?: number
  totalViewerCount?: number
  totalGiftAmount?: number
}

export interface LiveStatSourceVO {
  source?: string
  viewCount?: number
  viewerCount?: number
  totalWatchSeconds?: number
}

export const getRoomSummary = (liveId: number) =>
  request.get({ url: '/live/stat/room-summary', params: { liveId } })
export const getAnchorRank = (params: any) => request.get({ url: '/live/stat/anchor-rank', params })
export const getSourceDistribution = (liveId: number) =>
  request.get({ url: '/live/stat/source', params: { liveId } })
